import { ChessTermType, } from "@chesshotel/types";
import { Chess, KING, swapColor, PAWN, KNIGHT, BISHOP, QUEEN, } from "@chesshotel/chess";
import { pieceValues, exchangeEvaluation, uci2move, } from "../util.js";
function getRemovedPin(pinsBefore, pinsAfter) {
    let removedPin = null;
    for (let pin of pinsBefore) {
        if (pinsAfter.find((pin2) => pin2.mainPiece.square == pin.mainPiece.square &&
            pin2.attackedPiece.square == pin.attackedPiece.square) == null) {
            removedPin = pin;
            break;
        }
    }
    return removedPin;
}
function getAddedPin(pinsBefore, pinsAfter) {
    let addedPin = null;
    for (let pin of pinsAfter) {
        if (pinsBefore.find((pin2) => pin2.mainPiece.type == pin.mainPiece.type &&
            pin2.attackedPiece.type == pin.attackedPiece.type) == null) {
            addedPin = pin;
            break;
        }
    }
    return addedPin;
}
export function detectUnpin(fen, move) {
    const chess = new Chess(fen);
    const color = chess.turn();
    const pinsBefore = detectPins(fen, color);
    if (pinsBefore.length == 0) {
        return null;
    }
    const moveResult = chess.move(uci2move(move));
    if (chess.inCheck()) {
        return null;
    }
    const pinsAfter = detectPins(chess.fen(), color);
    if (pinsAfter.length < pinsBefore.length) {
        const pin = getRemovedPin(pinsBefore, pinsAfter);
        const translationKeys = { piece: pin.attackedPiece.type };
        const arrows = [
            { from: pin.mainPiece.square, to: pin.attackedPiece.square },
        ];
        return {
            ...pin,
            move: moveResult,
            term: ChessTermType.UNPIN,
            translationKeys,
            arrows,
        };
    }
}
export function detectPins(fen, color) {
    const chess = new Chess(fen);
    const opponentColor = swapColor(color);
    const oponentPieces = chess.pieces(opponentColor);
    const userPieces = chess.pieces(color);
    let pins = [];
    for (const piece of oponentPieces) {
        if (piece.type == KING || piece.type == KNIGHT || piece.type == PAWN) {
            continue;
        }
        for (const userPiece of userPieces) {
            const attackRay = chess.attackRay(userPiece.square, piece.square, opponentColor);
            if (attackRay) {
                const [firstPiece, nextPiece] = attackRay;
                const mainPiece = piece;
                const mainPieceValue = pieceValues[mainPiece.type];
                const firstPieceValue = pieceValues[firstPiece.type];
                const nextPieceValue = pieceValues[nextPiece.type];
                const isNextPieceDefended = chess.attackers(nextPiece.square, color).length > 0;
                const isPin = nextPieceValue >= firstPieceValue &&
                    (nextPieceValue > mainPieceValue || !isNextPieceDefended);
                if (mainPiece.type === BISHOP && firstPiece.type === BISHOP) {
                    continue;
                }
                if (mainPiece.type === QUEEN && firstPiece.type === QUEEN) {
                    continue;
                }
                if (!isPin) {
                    continue;
                }
                const maxGain = firstPieceValue - mainPieceValue;
                const pinMoveGain = isNextPieceDefended
                    ? mainPieceValue - nextPieceValue
                    : nextPieceValue;
                pins.push({
                    term: ChessTermType.PIN,
                    move: null,
                    mainPiece,
                    attackedPiece: firstPiece,
                    involvedPiece: nextPiece,
                    maxGain,
                    pinMoveGain,
                    pieceWin: firstPiece.type,
                });
                break;
            }
        }
    }
    return pins;
}
export function detectPinMove(fen, moveStr) {
    const chess = new Chess(fen);
    const color = chess.turn();
    if (chess.inCheck()) {
        return null;
    }
    const move = chess.move(uci2move(moveStr));
    const opponentColor = swapColor(color);
    if (move.piece == PAWN || move.piece == KING || move.piece == KNIGHT) {
        return null;
    }
    const exEval = exchangeEvaluation(chess.fen(), move.to, {
        backtrackBadMoves: true,
    });
    if (exEval.gain > 0) {
        return null;
    }
    if (chess.inCheck()) {
        return null;
    }
    const pinsBefore = detectPins(fen, opponentColor);
    const pinsAfter = detectPins(chess.fen(), opponentColor);
    const pin = getAddedPin(pinsBefore, pinsAfter);
    if (!pin) {
        return null;
    }
    const { attackedPiece, involvedPiece } = pin;
    const arrows = [{ from: move.to, to: involvedPiece.square }];
    const translationKeys = {
        piece: attackedPiece.type,
        piece2: involvedPiece.type,
    };
    return {
        ...pin,
        move,
        term: ChessTermType.PIN,
        translationKeys,
        arrows,
        maxGain: pin.maxGain,
    };
}
//# sourceMappingURL=pin.js.map